import HttpUtil from "@/utils/HttpUtil";

/**
 * 物业公司服务
 */
export default {
    /**
     * 获取列表
     * @param kw
     * @returns {Promise<unknown>}
     */
    getList(pageNum,pageSize,kw){
        return new Promise((resolve,reject)=>{
            HttpUtil.postJson("/data-center-provider/estateCompany/list",{
                kw,pageNum,pageSize
            }).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    },
    /**
     * 添加物业公司
     */
    addCompany(params){
        return new Promise((resolve,reject)=>{
            HttpUtil.postJson("/data-center-provider/estateCompany/create",params).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    },
    /**
     * 更新物业公司
     */
    updateCompany(id,params){
        return new Promise((resolve,reject)=>{
            HttpUtil.postJson("/data-center-provider/estateCompany/update/"+id,params).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    },
    //切换启用状态
    switchEnable(id,enable){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/estateCompany/switchEnable/"+id,{enable}).then(res=>{
                if (res.code === "ok"){
                    resolve(res.body);
                }else{
                    reject(res.msg);
                }
            }).catch(e=>{
                reject("网络请求异常");
            })
        });
    }
}
